<template>
  <nav class="navbar navbar-expand-lg fixed-top" :class="{ 'scrolled': isScrolled }">
    <div class="container align-items-center nav-container-line">
      <a class="navbar-brand" href="index.html" aria-label="Inicio">
        <img src="../assets/IMG/LOGO.png" id="logo" alt="Logo" />
      </a>

      <div class="navbar-collapse desktop-only" id="MENU">
        <ul class="navbar-nav ms-0 menu-left">
          <li v-for="menu in menus" :key="menu.id" class="nav-item">
            <a :href="menu.url" class="nav-link" v-text="menu.name"></a>
          </li>
        </ul>
      </div>

      <button
        class="btn btn-burger mobile-only burger-center"
        type="button"
        @click="isOpen = !isOpen"
        :aria-expanded="isOpen ? 'true' : 'false'"
        aria-label="Abrir menú"
      >
        <i class="bi" :class="isOpen ? 'bi-x-lg' : 'bi-list'"></i>
      </button>

      <div class="nav-actions ms-auto d-flex align-items-center">
        <a href="#" class="thumbnail" aria-label="Colombia">
          <img src="../assets/IMG/colombia.jpeg" alt="Bandera de Colombia" />
        </a>

        <button class="btn btn-arrow" @click="redireccion()" aria-label="Ir a login">
          <img src="../assets/IMG/Flecha.png" alt="Flecha" class="arrow-img" />
        </button>
      </div>

      <div v-show="isOpen" class="menu-overlay" @click="isOpen = false"></div>

      <transition name="menu-pop">
        <div v-show="isOpen" class="mobile-menu mobile-only" role="menu">
          <ul class="mobile-list">
            <li v-for="menu in menus" :key="menu.id" class="mobile-item">
              <a class="mobile-link" :href="menu.url" @click="isOpen = false">
                {{ menu.name }}
              </a>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </nav>
</template>

<script>
export default {
  name: "menu",
  data() {
    return {
      isOpen: false,
      isScrolled: false,
      menus: [
        { id: 1, name: "INICIO", url: "#" },
        { id: 2, name: "NOSOTROS", url: "#identification" },
        { id: 3, name: "NUESTRA TARJETA", url: "#card" },
        { id: 4, name: "SOLUCIONES", url: "#soluciones" },
        { id: 5, name: "CONTACTENOS", url: "#contacto" },
      ],
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 0;
    },
    redireccion() {
      window.location.href = "https://cardmaker.com.co/AUTH/login";
    },
  },
};
</script>
<style scoped>
.navbar {
  background: transparent !important;
  padding: 22px 0 10px;
  min-height: 64px;
  transition: background 300ms ease;
}

.navbar.scrolled {
  background: #00000096 !important;
}

.nav-container-line {
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  column-gap: 18px;
}

.nav-container-line::after {
  content: "";
  position: absolute;
  height: 2px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 999px;
  bottom: -1px;
  left: 0;
  right: 0;
  z-index: 1;
}

.navbar-brand {
  grid-column: 1;
  padding: 0;
  margin: 0;
  position: relative;
  z-index: 2;
}

#logo {
  width: 70px;
  height: auto;
  display: block;
}

.navbar-collapse.desktop-only {
  grid-column: 2;
  justify-self: center;
  display: flex;
  justify-content: center;
}

.menu-left {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 34px;
  margin: 0;
  padding: 0;
}

.navbar-nav .nav-link {
  color: #fff !important;
  white-space: nowrap;
  padding: 6px 10px;
  line-height: 1.1;
  font-size: 18px;
  text-align: center;
  font-weight: 200;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  border-radius: 999px;
  transition: background 160ms ease, opacity 160ms ease, transform 160ms ease;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.navbar-nav .nav-link:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-1px);
}

.nav-actions {
  grid-column: 3;
  justify-self: end;
  gap: 8px;
  position: relative;
  z-index: 2;
}

.thumbnail {
  display: inline-flex;
  align-items: center;
}

.thumbnail img {
  width: 42px;
  height: 32px;
  border-radius: 8px;
  display: block;
}

.btn-arrow {
  background: transparent !important;
  padding: 4px 8px;
  border-radius: 12px;
  line-height: 1;
  transition: transform 160ms ease, background 160ms ease, border-color 160ms ease;
}

.btn-arrow .arrow-img {
  width: 34px;
  height: 34px;
  display: block;
}

.btn-arrow:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.35);
  transform: translateY(-1px);
}

.btn-burger {
  grid-column: 2;
  justify-self: center;
  background: rgba(0, 0, 0, 0.35) !important;
  border: 1px solid rgba(255, 255, 255, 0.25);
  padding: 5px 9px;
  border-radius: 12px;
  line-height: 1;
  transition: transform 180ms ease, background 160ms ease, border-color 160ms ease;
  position: relative;
  z-index: 3;
}

.btn-burger i {
  color: rgba(255, 255, 255, 0.95);
  font-size: 18px;
  transition: transform 180ms ease, opacity 180ms ease;
}

.btn-burger:hover {
  background: rgba(255, 255, 255, 0.06) !important;
  border-color: rgba(255, 255, 255, 0.35);
  transform: translateY(-1px);
}

.btn-burger[aria-expanded="true"] i {
  transform: rotate(90deg) scale(1.02);
}

.burger-center {
  position: static;
  left: auto;
  top: auto;
  transform: none;
}

.navbar-nav .nav-link:focus-visible,
.btn-arrow:focus-visible,
.btn-burger:focus-visible,
.thumbnail:focus-visible,
.mobile-link:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.55);
  outline-offset: 3px;
  border-radius: 12px;
}

.menu-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.22);
  backdrop-filter: blur(2px);
  z-index: 9998;
}

.mobile-menu {
  position: fixed;
  left: 50%;
  top: 74px;
  transform: translateX(-50%);
  z-index: 9999;
  width: min(340px, 92vw);
  padding: 14px 14px 12px;
  background: rgba(0, 0, 0, 0.70);
  border: none;
  border-radius: 14px;
  backdrop-filter: blur(8px);
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.35);
  transform-origin: top center;
}

.mobile-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
}

.mobile-link {
  display: block;
  width: 100%;
  text-align: center;
  padding: 8px 10px;
  background: transparent;
  border: none;
  border-radius: 0;
  color: #fff;
  text-decoration: none;
  font-weight: 200;
  font-size: 12.5px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  transition: opacity 160ms ease, transform 180ms ease;
}

.mobile-link:hover {
  opacity: 0.85;
  transform: translateY(-1px);
}

.menu-pop-enter-active,
.menu-pop-leave-active {
  transition: opacity 200ms ease, transform 240ms ease;
}

.menu-pop-enter-from,
.menu-pop-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-10px) scale(0.98);
}

.menu-pop-enter-to,
.menu-pop-leave-from {
  opacity: 1;
  transform: translateX(-50%) translateY(0) scale(1);
}

.desktop-only { display: flex; }
.mobile-only { display: none; }

@media (max-width: 991px) {
  .desktop-only { display: none !important; }
  .mobile-only { display: inline-flex; }
  .nav-container-line {
    grid-template-columns: auto 1fr auto;
  }
  .btn-burger {
    grid-column: 2;
    justify-self: center;
  }
  .nav-actions {
    grid-column: 3;
    justify-self: end;
  }
  #logo { width: 58px; }
  .thumbnail img { width: 30px; height: 22px; }
  .btn-arrow { padding: 4px 7px; }
  .btn-arrow .arrow-img { width: 22px; height: 22px; }
  .nav-container-line::after { bottom: 4px; }
  .mobile-menu { top: 70px; }
}

@media (max-width: 480px) {
  #logo { width: 52px; }
  .thumbnail img { width: 28px; height: 20px; }
  .btn-arrow .arrow-img { width: 20px; height: 20px; }
  .mobile-menu { top: 66px; width: min(320px, 92vw); }
}
</style>
